import React from 'react'
import classNames from 'classnames'

export const Separator = ({ className }: { className?: string }): React.JSX.Element => {
    return (
        <div className={classNames('h-[0.5px] bg-secondary', className)}></div>
    )
}
